import React, { useState } from 'react';
import './ChatbotButton.css';
import ChatWindow from './ChatWindow'; // 👈 new component we'll create

const ChatbotButton = () => {
  const [hasNewMessage, setHasNewMessage] = useState(true);
  const [isChatOpen, setIsChatOpen] = useState(false);

  const handleClick = () => {
    setHasNewMessage(false);
    setIsChatOpen(true);
  };

  return (
    <>
      <div id='ChatbotButton' className="chatbot-button-container" onClick={handleClick}>
        <div className="chatbot-icon">
          <span className="chatbot-cursor">🖱️</span>
        </div>
        {hasNewMessage && <div className="notification-badge">1</div>}
      </div>

      {isChatOpen && <ChatWindow onClose={() => setIsChatOpen(false)} />}
    </>
  );
};

export default ChatbotButton;
